"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useCardContextValue", {
    enumerable: true,
    get: ()=>useCardContextValue
});
function useCardContextValue({ selectableA11yProps  }) {
    return {
        selectableA11yProps
    };
} //# sourceMappingURL=useCardContextValue.js.map

//# sourceMappingURL=useCardContextValue.js.map